module.exports = {"house_number":"Hausnummer","enter_house_number":"Gib die Hausnummer ein"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/house.json
// module id = 489
// module chunks = 248 1688